import React from "react";
import { dateValue, SectionTitle } from "../EmployeeForm";
import { Calendar } from "primereact/calendar";
import { toIST } from "../../../utils/calculateMargin";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "../../../ui/buttons";
import { Plus, Trash2 } from "lucide-react";

const educationTypeOptions = ["Regular", "Distance", "Part Time"].map((x) => ({
  label: x,
  value: x,
}));

function Education({
  educationDetails,
  setEducationDetails,
  updateArray,
  removeArrayItem,
  emptyEducation,
}) {
  return (
    <section className="flex flex-col gap-3">
      <SectionTitle>Education</SectionTitle>

      {educationDetails.map((item, index) => (
        <div
          key={index}
          className="grid grid-cols-1 lg:grid-cols-6 gap-3 border p-3 rounded-md"
        >
          <Calendar
            value={dateValue(item.fromDate)}
            onChange={(e) =>
              updateArray(
                setEducationDetails,
                index,
                "fromDate",
                toIST(e.value),
              )
            }
            showIcon
            dateFormat="dd/mm/yy"
            placeholder="From *"
            className="w-full bg-input border border-gray-300 rounded-md"
            inputClassName="w-full px-3 py-1.5 bg-input shadow-none focus:outline-none"
          />

          <Calendar
            value={dateValue(item.toDate)}
            onChange={(e) =>
              updateArray(setEducationDetails, index, "toDate", toIST(e.value))
            }
            showIcon
            dateFormat="dd/mm/yy"
            placeholder="To *"
            className="w-full bg-input border border-gray-300 rounded-md"
            inputClassName="w-full px-3 py-1.5 bg-input shadow-none focus:outline-none"
          />

          <InputText
            value={item.instituteName}
            onChange={(e) =>
              updateArray(
                setEducationDetails,
                index,
                "instituteName",
                e.target.value,
              )
            }
            placeholder="Institute *"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />

          <Dropdown
            value={item.type}
            options={educationTypeOptions}
            onChange={(e) =>
              updateArray(setEducationDetails, index, "type", e.value)
            }
            placeholder="Type *"
            className="w-full px-1 text-sm border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />

          <InputText
            value={item.courseName}
            onChange={(e) =>
              updateArray(
                setEducationDetails,
                index,
                "courseName",
                e.target.value,
              )
            }
            placeholder="Course *"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />

          <div className="flex gap-2">
            <InputText
              value={item.location}
              onChange={(e) =>
                updateArray(
                  setEducationDetails,
                  index,
                  "location",
                  e.target.value,
                )
              }
              placeholder="Location *"
              className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
            />
            <Button
              type="button"
              variant="ghost"
              disabled={educationDetails.length === 1}
              onClick={() => removeArrayItem(setEducationDetails, index)}
            >
              <Trash2 className="h-4 w-4 text-red-500" />
            </Button>
          </div>
        </div>
      ))}

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() =>
          setEducationDetails((prev) => [...prev, { ...emptyEducation }])
        }
        className="w-fit"
      >
        <Plus className="h-4 w-4 mr-1" />
        Add Education
      </Button>
    </section>
  );
}

export default Education;
